export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)
}